import { render, staticRenderFns } from "./CartSidebarContent.vue?vue&type=template&id=27b2c524&scoped=true&"
import script from "./CartSidebarContent.vue?vue&type=script&lang=js&"
export * from "./CartSidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./CartSidebarContent.vue?vue&type=style&index=0&id=27b2c524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b2c524",
  null
  
)

export default component.exports